module.exports = __webpack_public_path__ + "static/media/idun7.33cdaa38.JPG";